import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {UserService} from '../../../services/user/user.service';
import {User} from '../../../model/user';
import {Store} from '@ngrx/store';
import {ProposalUser} from '../../../model/proposal/proposalUser';
import {selectUser} from '../../../store/user/selectors/user.selectors';
import {StrapiService} from '../../../services/strapi-service/strapi.service';
import {map, Observable} from 'rxjs';
import {Announcement} from '../../../model/strapi/announcement/announcement';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-announcements-dialog',
    templateUrl: './announcements-dialog.component.html',
    styleUrls: ['./announcements-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AnnouncementsDialogComponent implements OnInit{

  disableAnnouncementDialog: boolean = false;
  activeUserId: string = null;

  announcement$: Observable<Announcement> = this.strapiService.getAnnouncements().pipe(map(announcements => announcements[0]));

  constructor(private readonly strapiService: StrapiService,
              public dialogRef: MatDialogRef<AnnouncementsDialogComponent>,
              private readonly userService: UserService,
              private readonly userStore: Store<ProposalUser>) {
  }

  ngOnInit(): void {
    this.userStore.select(selectUser).subscribe(user => {
      if (!user.showAnnouncementDialog) {
        this.dialogRef.close();
      }
      this.activeUserId = user.id;
    });
  }

  toggleAnnouncementDialog() {
    if (this.disableAnnouncementDialog) {
      let user = new User();
      user.showAnnouncementDialog = !this.disableAnnouncementDialog;
      this.userService.updateUser(this.activeUserId, user)?.subscribe();
    }
    this.dialogRef.close();
  }
}
